import { render, staticRenderFns } from "./UploadInapp.vue?vue&type=template&id=6e522a98&"
import script from "./UploadInapp.vue?vue&type=script&lang=ts&"
export * from "./UploadInapp.vue?vue&type=script&lang=ts&"
import style0 from "./UploadInapp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports